import { useCallback, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

// True when a CommonMessageReducer / API response represents a failure.
// Status strings are compared case-insensitively ('Success' and 'success' are both ok).
export const isErrorMessage = (msg: any): boolean => {
    if (!msg) return false;
    if ((msg.code && msg.code >= 400) || (msg.statusCode && msg.statusCode >= 400)) return true;
    if (typeof msg.status === 'number') return msg.status >= 400;
    if (typeof msg.status === 'string') {
        const status = msg.status.trim().toLowerCase();
        return status !== '' && status !== 'success';
    }
    return false;
};

export const useCaptcha = () => {
    const captchaRef = useRef<ReCAPTCHA>(null);
    const [captchaToken, setCaptchaToken] = useState<string | null>(null);

    const resetCaptcha = useCallback(() => {
        captchaRef.current?.reset();
        setCaptchaToken(null);
    }, []);

    return { captchaRef, captchaToken, setCaptchaToken, resetCaptcha };
};
